<template>
  <!-- Cabeçalho: a marca à esquerda, o jogador à direita.
       Os elos são a energia da trilha, desenhados como elo de corrente — o mesmo elo do
       símbolo. Elo gasto fica apagado, e não some: o jogador precisa ver quantos tinha. -->
  <header class="bar">
    <!-- O logotipo é máscara, não imagem: o arquivo da marca é branco, e no tema claro
         ele sumiria no fundo. Como máscara ele assume a cor do texto do tema. -->
    <router-link to="/hoje" class="brand" aria-label="Sentido">
      <span class="logo" role="img" aria-label="Sentido" :style="logoMask" />
    </router-link>

    <div class="right">
      <div v-if="linksMax" class="chip chip-links" :title="`${links} de ${linksMax} elos`">
        <AppIcon
          v-for="n in linksMax"
          :key="n"
          name="link"
          size="sm"
          :class="{ spent: n > links }"
        />
      </div>

      <!-- O perfil mora aqui desde que a trilha tomou a aba dele: a identidade é o que se
           lê de relance no topo, e a barra de baixo ficou para os cinco destinos de jogo. -->
      <router-link to="/perfil" class="me" :aria-label="`Perfil de ${name}`">
        <span class="face">{{ initial }}</span>
        <span class="lvl">lvl {{ level }}</span>
      </router-link>
    </div>
  </header>
</template>

<script>
import AppIcon from './ui/AppIcon.vue';

export default {
  name: 'AppBar',
  components: { AppIcon },
  props: {
    /** Energia da trilha. Zero em `linksMax` esconde o chip: fora da trilha ele não diz nada. */
    links: { type: Number, default: 0 },
    linksMax: { type: Number, default: 0 },
    /** Quem está jogando. Anônimo não tem apelido, e o avatar cai na letra do rótulo. */
    name: { type: String, default: 'Anônimo' },
    level: { type: Number, default: 1 },
  },
  computed: {
    /* A máscara vem do `public/`, e por isso é montada aqui: no CSS o empacotador tenta
       resolver a URL como módulo e não acha o arquivo. */
    logoMask() {
      const url = `url(${process.env.BASE_URL}marca/logotipo-branco.svg)`;
      return { maskImage: url, WebkitMaskImage: url };
    },
    initial() {
      return (this.name || 'Anônimo').trim().charAt(0).toUpperCase();
    },
  },
};
</script>

<style scoped>
.bar {
  grid-area: bar;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  padding: 12px 20px;
}

.brand { display: flex; align-items: center; min-width: 0; color: var(--text); }

.logo {
  display: block;
  width: 153px;
  height: 19px;
  background: currentColor;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: left center;
  mask-position: left center;
}

.right { display: flex; align-items: center; gap: 7px; flex: none; }

.chip-links { background: var(--magenta-veil); color: var(--pink-text); gap: 3px; }
.chip-links .spent { opacity: 0.28; }

/* O avatar é o alvo, e o nível é a legenda dele. Pílula em vez de chip quadrado: é a forma
   que o app já usa para identidade (o cartão do jogador e o pódio). */
.me {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  padding: 3px 10px 3px 3px;
  border-radius: var(--r-pill);
  border: 1px solid var(--line-2);
  background: var(--veil-1);
  color: var(--text-2);
  text-decoration: none;
  font-family: var(--f-label);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  transition: border-color 0.16s, color 0.16s;
}

.me:hover,
.me.router-link-active { border-color: var(--text-3); color: var(--text); }

.face {
  width: 28px;
  height: 28px;
  flex: none;
  border-radius: var(--r-pill);
  display: grid;
  place-items: center;
  background: var(--brand-gradient);
  color: var(--on-brand);
  font: 700 12px/1 var(--f-title);
  letter-spacing: 0;
}

.lvl { white-space: nowrap; }
</style>
